// extracted by mini-css-extract-plugin
export default {"page":"Page_Teacher_Tareas_page__uw36T","loading":"Page_Teacher_Tareas_loading__oWu+b"};